import { render, staticRenderFns } from "./TrsServerSelection.vue?vue&type=template&id=603d6f0a&scoped=true"
import script from "./TrsServerSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrsServerSelection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrsServerSelection.vue?vue&type=style&index=0&id=603d6f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d6f0a",
  null
  
)

export default component.exports